    (function () {
      /* ONE SCRIPT, MORE THAN ONE PRODUCT, 2026-10-06 — owner: the product
         embedded in a blog post must behave exactly like the product page. On
         the product page there is one gallery and #hl-variant-media is its
         map. On an article there is no such node (it is rendered at page level,
         outside the sections the embed mounts) and there can be several
         galleries: the embed, and the sheet opened over it. So the script no
         longer returns when the node is missing, and everything that used to
         look the gallery up on `document` looks it up in SCOPE — the mount
         whose picker just changed. hl-pdp-modal.js hands each mount its map
         through HLVariantSwap.attach(). On the product page SCOPE stays the
         document and nothing below behaves differently. */
      var node = document.getElementById('hl-variant-media');
      var MAP = {};
      if (node) { try { MAP = JSON.parse(node.textContent); } catch (e) { MAP = {}; } }
      var PAGE_MAP = MAP;
      var SCOPE = document;

      var TITLES, VARIANT_MEDIA;
      // Every media id that belongs to some variant. Only these may be removed
      // from the strip — the ordinary gallery photographs are not ours to touch,
      // and this is the same rule `hide_variants` applies on the server.
      function setMap(map) {
        MAP = map || {};
        TITLES = Object.keys(MAP);
        VARIANT_MEDIA = {};
        TITLES.forEach(function (t) { if (MAP[t].mediaId) VARIANT_MEDIA[MAP[t].mediaId] = 1; });
      }
      setMap(MAP);

      function slidesRoot() { return SCOPE.querySelector('media-gallery slideshow-slides'); }
      function slideList(root) { return [].slice.call((root || document).querySelectorAll('slideshow-slide')); }
      function mediaIdOf(slide) {
        var m = slide.querySelector('[data-media-id]');
        return m ? m.getAttribute('data-media-id') : null;
      }
      function atWidth(url, w) {
        if (!url) return url;
        return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url;
      }

      /* CLONING A LOADED <img> FETCHES ITS PICTURE ALL OVER AGAIN.

         cloneNode(true) copies the src and srcset attributes, and the clone —
         detached or not — runs the browser's "update the image data" for THOSE
         attributes before the next statement can overwrite them. Overwriting
         synchronously two lines later does not stop it: measured on
         globe-pull-chain-wall-sconce at 433px, every variant tap fired one
         width=1600 GET for the OUTGOING photograph — 112 KB on the first tap,
         137 KB on the second — initiated by syncZoom, for a picture thrown away
         before it could ever be shown. It happens on live too; it is 95% of the
         bytes a variant tap costs there.

         An inert document has no browsing context, so images parsed into one do
         not load at all. The clone is taken there, rewritten to point at the
         photograph we actually want, and only then imported into this document —
         at which point the only URL it has ever had is the right one.

         importNode, not adoptNode: it creates the elements in THIS document, so
         <slideshow-slide> and <drag-zoom-wrapper> are upgraded exactly as a
         cloneNode result would have been. */
      var INERT = null;
      function inertClone(node) {
        if (!node) return null;
        try {
          if (!INERT) INERT = document.implementation.createHTMLDocument('');
          var host = INERT.createElement('div');
          host.innerHTML = node.outerHTML;
          return host.firstElementChild;
        } catch (e) {
          // Never fail the swap over an optimisation. A cloneNode costs one
          // wasted request; not swapping at all costs the shopper the picture.
          return node.cloneNode(true);
        }
      }
      function adoptClone(node) {
        return node && node.ownerDocument !== document ? document.importNode(node, true) : node;
      }

      /* The width to warm.

         Not a guess and not a fixed 1200: the browser has already resolved this
         gallery's srcset against its own `sizes`, DPR and viewport, and the
         answer is sitting in currentSrc. Reading it back means the preloaded URL
         is byte-for-byte the one the injected <img> will ask for, which is the
         difference between a cache hit and a second download. */
      var W = null;
      function targetWidth() {
        if (W) return W;
        var img = SCOPE.querySelector('media-gallery slideshow-slide img');
        var m = img && img.currentSrc && img.currentSrc.match(/[?&]width=(\d+)/);
        // Only a real answer is remembered. The old code cached the 1200
        // FALLBACK forever, so a warm-up that ran before the gallery image had
        // resolved its srcset pinned every injected photograph to width=1200
        // while the page itself was rendering a different rung -- a different
        // URL, and therefore a second download at the morph.
        if (m) W = m[1];
        return W || '1200';
      }

      /* THE SAME RUNG THE SERVER WILL ASK FOR.

         The theme's own <img> carries a twelve-candidate srcset and a `sizes`,
         and the browser resolves those against this device's width and DPR. A
         single hard-coded src cannot know that answer -- on a DPR-3 phone it is
         a different candidate than on this DPR-2 one. When the theme replaces
         the gallery ~800ms-2.4s later, its <img> resolves the rung it wants; if
         that is not the URL sitting in the injected slide, the browser has to
         fetch and decode a file it has never seen, and the photograph blinks
         out and comes back. Same picture, different URL.

         So the injected slide gets a srcset of the same shape -- the variant's
         file at exactly the widths the model offers -- plus the model's own
         `sizes`. Both sides of the morph then resolve to the identical URL. */
      function srcsetFor(modelImg, v) {
        var ss = modelImg && modelImg.getAttribute('srcset');
        if (!ss || !v.src) return null;
        var out = [];
        ss.split(',').forEach(function (c) {
          var m = c.trim().match(/(\d+)w$/);
          if (m) out.push(atWidth(v.src, m[1]) + ' ' + m[1] + 'w');
        });
        return out.length ? out.join(', ') : null;
      }

      /* A <picture> DECIDES BEFORE THE <img> DOES, AND THE CLONE KEPT THE OLD ONE.

         buildSlide and syncZoom rewrote the <img>'s src and srcset and nothing
         else. The theme wraps every gallery photograph in
         <picture class="hl-img"><source srcset="...width=400"><img></picture>,
         and a <source> that matches wins outright — the <img>'s own srcset is
         never consulted. So the injected slide carried the NEW variant's
         data-media-id and the NEW variant's <img>, and painted the OLD
         variant's photograph.

         Measured on globe-pull-chain-wall-sconce, 150ms after picking Beige:
         data-media-id 31060352958511 (beige), img src img_10_variant-c-beige,
         and currentSrc img_09_variant-c-GREEN — the outgoing photograph, on
         screen for the ~400ms until the server's gallery replaced it. That is
         the "instant swap" showing the wrong picture, and tools/
         variant_swap_test.mjs could not see it because it reads data-media-id,
         which was right the whole time. */
      function rewriteSources(node, v) {
        if (!v || !v.src || !node || !node.querySelectorAll) return;
        var sources = node.querySelectorAll('source');
        for (var i = 0; i < sources.length; i++) {
          var ss = sources[i].getAttribute('srcset');
          if (!ss) continue;
          var out = [];
          ss.split(',').forEach(function (c) {
            c = c.trim();
            if (!c) return;
            var m = c.match(/[?&]width=(\d+)/);
            if (!m) { out.push(c); return; }
            var desc = c.replace(/^\S+/, '').trim();   // "2x", "400w", or nothing
            out.push(atWidth(v.src, m[1]) + (desc ? ' ' + desc : ''));
          });
          if (out.length) sources[i].setAttribute('srcset', out.join(', '));
        }
      }

      function modelImg() {
        var root = slidesRoot();
        return root && root.querySelector('slideshow-slide img');
      }

      /* Built once, at idle, not on the click.

         Measured: the click handler ran for 47.6ms synchronously, which is a
         dropped frame on its own — and cloning a slide whose <img> carries a
         twelve-candidate srcset is most of it. Doing that work before the
         shopper touches anything leaves the click as two DOM moves. */
      var BUILT = {};
      function prebuild() {
        var root = slidesRoot();
        var model = root && root.querySelector('slideshow-slide');
        if (!model) return;
        TITLES.forEach(function (t) {
          var v = MAP[t];
          if (!v.mediaId || BUILT[v.mediaId]) return;
          var made = buildSlide(model, v);
          if (made) BUILT[v.mediaId] = made;
        });
      }

      /* The rungs the <picture>'s <source> elements ask for, which are NOT the
         ones the <img>'s srcset asks for. On a phone the gallery's source
         answers width=400 while the img's own candidates start at 800, so a
         warm-up built from the <img> alone left the rung the browser actually
         uses stone cold — and once rewriteSources made the injected slide point
         at the RIGHT photograph, that cold rung became a visible wait where
         before there had been the wrong picture, instantly. */
      function sourceWidths() {
        var root = slidesRoot();
        var model = root && root.querySelector('slideshow-slide');
        var out = [], seen = {};
        if (!model) return out;
        var sources = model.querySelectorAll('picture source');
        for (var i = 0; i < sources.length; i++) {
          var ss = sources[i].getAttribute('srcset') || '';
          ss.split(',').forEach(function (c) {
            var m = c.match(/[?&]width=(\d+)/);
            if (m && !seen[m[1]]) { seen[m[1]] = 1; out.push(m[1]); }
          });
        }
        return out;
      }

      function preload() {
        var model = modelImg(), seen = {};
        var sizes = model && model.getAttribute('sizes');
        var swidths = sourceWidths();
        TITLES.forEach(function (t) {
          var v = MAP[t];
          if (v.src && !seen[v.src]) {
            seen[v.src] = 1;
            var i = new Image();
            i.decoding = 'async';
            var ss = srcsetFor(model, v);
            if (ss) {
              // An Image() resolves srcset against the viewport the same way the
              // document's <img> does, so this warms the exact candidate the
              // gallery will ask for rather than a guessed width.
              if (sizes) i.sizes = sizes;
              i.srcset = ss;
            }
            i.src = ss ? atWidth(v.src, 3840) : atWidth(v.src, targetWidth());
          }
          for (var w = 0; w < swidths.length; w++) {
            var su = atWidth(v.src, swidths[w]);
            if (su && !seen[su]) { seen[su] = 1; var si = new Image(); si.decoding = 'async'; si.src = su; }
          }
          var th = atWidth(v.thumb, 144);
          if (th && !seen[th]) {
            seen[th] = 1;
            var it = new Image();
            it.decoding = 'async';
            it.src = th;
          }
        });
      }

      // ---- the swap ------------------------------------------------------
      function buildSlide(model, v) {
        var slide = inertClone(model);
        var pm = slide && slide.querySelector('[data-media-id]');
        if (!pm) return null;
        rewriteSources(slide, v);
        pm.setAttribute('data-media-id', v.mediaId);
        pm.style.setProperty('--ratio', v.ratio);

        var img = slide.querySelector('img');
        if (img) {
          // The model's candidate list with this variant's file in it, so the
          // browser picks the same rung here and in the server's replacement.
          // Falling back to one warmed candidate only if the model has none.
          var mi = model.querySelector('img');
          var ss = srcsetFor(mi, v);
          if (ss) {
            var sizes = mi && mi.getAttribute('sizes');
            if (sizes) img.setAttribute('sizes', sizes);
            img.setAttribute('srcset', ss);
            img.setAttribute('src', atWidth(v.src, 3840));   // what the server writes too
          } else {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.setAttribute('src', atWidth(v.src, targetWidth()));
          }
          img.setAttribute('data_max_resolution', atWidth(v.src, 3840));
          img.setAttribute('alt', v.alt || '');
          img.setAttribute('fetchpriority', 'high');
          img.removeAttribute('loading');
        }
        // A cloned <video> would restart and autoplay; the variant photograph is
        // an image by definition, so anything else in the model is dropped.
        [].slice.call(slide.querySelectorAll('video, model-viewer, iframe')).forEach(function (n) { n.remove(); });
        slide.setAttribute('data-hl-injected', '1');
        return adoptClone(slide);
      }

      function renumber(root) {
        slideList(root).forEach(function (s, i) {
          s.style.setProperty('--slideshow-timeline', '--slide-' + i);
          ['data-hl-zoom-parked', 'on:click'].forEach(function (attr) {
            var val = s.getAttribute(attr);
            if (val) s.setAttribute(attr, val.replace(/\/open\/\d+$/, '/open/' + i));
          });
        });
      }

      /* Thumbnails, rebuilt from the slides rather than patched.

         The previous version cloned the first thumbnail, removed the original,
         and then inserted the clone BEFORE that same removed node. insertBefore
         throws NotFoundError when the reference node is no longer a child, so
         every variant click deleted one thumbnail, never added its replacement,
         and killed the rest of the handler at that line. Reproduced on the
         fluted wall panel: six thumbnails became five on the first click and
         stayed there, with one NotFoundError per click; scrolling only appeared
         to fix it because the theme re-renders the gallery.

         The thumbnails mirror the slides one for one, so the slides are the
         source of truth. Existing thumbnails are MOVED into the new order —
         appendChild moves a node that is already a child, so they keep their
         decoded images — and a thumbnail is only cloned for a slide that does
         not have one yet. Nothing is removed until the new order is in place. */
      function syncThumbnails(v) {
        var strip = SCOPE.querySelector('media-gallery slideshow-controls');
        if (!strip) return;
        /* Measured again on a 412px viewport: the strip IS in the document with
           all eight thumbnails, its computed display is NOT 'none', and every
           box measures 0x0 with no offsetParent. So the old guard never fired
           and this rebuild ran on every tap -- 109ms of profiled main thread on
           a phone that cannot show a single thumbnail. Measure the box. */
        if (!strip.offsetParent || strip.getBoundingClientRect().width === 0) return;

        var thumbs = [].slice.call(strip.querySelectorAll('.slideshow-controls__thumbnail'));
        if (thumbs.length < 2) return;
        var parent = thumbs[0].parentElement;
        var slides = slideList(slidesRoot());
        if (!slides.length) return;

        function fileOf(el) {
          var img = el.querySelector('img');
          if (!img) return null;
          var src = img.getAttribute('src') || img.currentSrc || '';
          return src.split('?')[0].split('/').pop() || null;
        }

        var pool = {};
        thumbs.forEach(function (b) { var f = fileOf(b); if (f && !pool[f]) pool[f] = b; });

        var order = [];
        slides.forEach(function (s) {
          var f = fileOf(s);
          var b = f && pool[f];
          if (b) delete pool[f];
          else {
            b = inertClone(thumbs[0]);
            rewriteSources(b, v);
            var img = b.querySelector('img');
            if (img) {
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
              img.setAttribute('src', atWidth(v.thumb, 144));
              img.setAttribute('alt', v.alt || '');
            }
            b.setAttribute('data-hl-variant-thumb', '1');
            b = adoptClone(b);
          }
          order.push(b);
        });

        order.forEach(function (b) { parent.appendChild(b); });
        thumbs.forEach(function (b) { if (order.indexOf(b) === -1) b.remove(); });

        order.forEach(function (b, i) {
          var on = b.getAttribute('on:click');
          if (on) b.setAttribute('on:click', on.replace(/\/select\/\d+$/, '/select/' + i));
          b.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + order.length);
          b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        });
      }

      /* The zoom dialog holds the same media in the same order as the strip,
         as its own copy. Measured after a swap and before the server's reply:
         strip starts at the variant's photograph, zoom-dialog still starts at
         the old one — so for the ~600ms in between, tapping the picture opened
         the wrong image at full size. The dialog gets the same treatment. */
      function unitsOf(container, marks) {
        return marks.map(function (m) {
          var n = m;
          while (n.parentElement && n.parentElement !== container) n = n.parentElement;
          return n;
        });
      }

      /* THE LOCKSTEP WALK CAN LEAVE THE DIALOG, AND THEN IT REMOVES <body>.

         Climbing marks[0] and marks[1] one level at a time only converges if
         the two sit at the SAME depth, and in this dialog they need not: an
         image is wrapped in <drag-zoom-wrapper> and a video or a 3D model is
         not (product-media-gallery-content.liquid renders the two branches
         differently). sorted_media always puts the selected variant's image
         first, so marks[0] is always the deep one; if the second media is a
         clip, the two are permanently one level apart, never share a parent,
         and the walk climbs all the way out — a.parentElement ends up <html>.

         What follows from that is not a cosmetic bug. unitsOf then calls every
         unit <body>; the selected variant's media is absent from the dialog
         under hide_variants so `target` misses and gets built from a clone of
         units[0]; the removal loop matches marks[0]'s id in VARIANT_MEDIA and
         calls u.remove() on <body>; and the last line inserts the clone into
         <html> before <head>. The page goes blank on the first colour tap.

         No product in the catalogue has that shape today — all 949 were checked
         on 2026-09-12 and the 13 that carry a video carry it LAST, never second
         — so this has never fired. It is one media reorder in the admin away
         from firing, and the fix is a lookup rather than a deduction: the list
         is right there in the markup. The walk is kept as a fallback for markup
         that does not have the class, and is now refused if it lands anywhere
         outside the dialog.

         Returning the real <ul> also FIXES the mixed-media case rather than
         merely surviving it: unitsOf then resolves a video's mark to its own
         <li> exactly as it does an image's. */
      function commonContainer(marks, root) {
        var direct = root && root.querySelector('.dialog-zoomed-gallery');
        if (direct) return direct;
        var a = marks[0], b = marks[1];
        while (a.parentElement && b.parentElement && a.parentElement !== b.parentElement) {
          a = a.parentElement; b = b.parentElement;
        }
        var c = a.parentElement;
        return c && root && c !== root && root.contains(c) ? c : null;
      }

      var ZBUILT = {};
      function syncZoom(v) {
        var zd = SCOPE.querySelector('zoom-dialog');
        if (!zd) return;
        var marks = [].slice.call(zd.querySelectorAll('[data-media-id]'));
        if (marks.length < 2) return;
        var container = commonContainer(marks, zd);
        if (!container) return;
        var units = unitsOf(container, marks);

        var target = null;
        for (var i = 0; i < marks.length; i++) {
          if (marks[i].getAttribute('data-media-id') === String(v.mediaId)) { target = units[i]; break; }
        }
        if (!target) {
          target = ZBUILT[v.mediaId];
          if (!target) {
            target = inertClone(units[0]);
            var pm = target.querySelector('[data-media-id]') || target;
            pm.setAttribute('data-media-id', v.mediaId);
            rewriteSources(target, v);
            [].slice.call(target.querySelectorAll('img')).forEach(function (img) {
              var ss = srcsetFor(img, v);
              if (ss) {
                img.setAttribute('srcset', ss);          // keeps its own sizes
                img.setAttribute('src', atWidth(v.src, 3840));
              } else {
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
                img.setAttribute('src', atWidth(v.src, targetWidth()));
              }
              img.setAttribute('alt', v.alt || '');
            });
            [].slice.call(target.querySelectorAll('video, model-viewer, iframe')).forEach(function (n) { n.remove(); });
            target.setAttribute('data-hl-injected', '1');
            target = adoptClone(target);
            ZBUILT[v.mediaId] = target;
          }
        }
        units.forEach(function (u, i) {
          if (u === target) return;
          var id = marks[i].getAttribute('data-media-id');
          if (u.getAttribute('data-hl-injected') === '1' || (id && VARIANT_MEDIA[id])) u.remove();
        });
        if (target !== container.firstElementChild) container.insertBefore(target, container.firstElementChild);
        syncZoomThumbs(zd, v);
      }

      /* THE DIALOG HAS A THUMBNAIL RAIL TOO, AND IT WAS LEFT BEHIND.

         syncZoom finds what to move by querying [data-media-id], and the rail's
         buttons are rendered through hl-img, which emits none — so the <li>
         list was reordered on every swap and the rail never was. The result a
         shopper sees: pick a colour, tap the photograph inside the window before
         the server's gallery lands (~800ms on a laptop, ~2.4s on a phone), and
         the big image is the new variant while thumbnail #1 underneath it is
         still the old one. The rail is also what names the position, so it was
         naming the wrong one.

         Rebuilt from the <li> order the same way syncThumbnails rebuilds the
         main strip, and for the same reason: the slides are the source of
         truth, existing buttons are MOVED so they keep their decoded images,
         and nothing is removed until the new order is in place. The indices in
         on:click and on:pointerenter are positions in refs.media, so they are
         renumbered against the new order rather than left pointing at what used
         to be there. */
      function syncZoomThumbs(zd, v) {
        var rail = zd.querySelector('.dialog-thumbnails-list');
        if (!rail) return;
        var btns = [].slice.call(rail.querySelectorAll('.dialog-thumbnails-list__thumbnail'));
        if (btns.length < 2) return;
        var parent = btns[0].parentElement;
        var lis = [].slice.call(zd.querySelectorAll('.dialog-zoomed-gallery > li'));
        if (!lis.length) return;

        function fileOf(el) {
          var img = el.querySelector('img');
          if (!img) return null;
          var src = img.getAttribute('src') || img.currentSrc || '';
          return src.split('?')[0].split('/').pop() || null;
        }

        var pool = {};
        btns.forEach(function (b) { var f = fileOf(b); if (f && !pool[f]) pool[f] = b; });

        var order = [];
        lis.forEach(function (li) {
          var f = fileOf(li);
          var b = f && pool[f];
          if (b) delete pool[f];
          else {
            b = inertClone(btns[0]);
            // The rail is <picture> markup, so the <source> decides before the
            // <img> does; rewriting only the img would paint the old thumbnail
            // behind the new one's src.
            rewriteSources(b, v);
            var img = b.querySelector('img');
            if (img) {
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
              img.setAttribute('src', atWidth(v.thumb, 180));
              img.setAttribute('alt', v.alt || '');
            }
            b.setAttribute('data-hl-variant-thumb', '1');
            b = adoptClone(b);
          }
          order.push(b);
        });

        order.forEach(function (b) { parent.appendChild(b); });
        btns.forEach(function (b) { if (order.indexOf(b) === -1) b.remove(); });

        order.forEach(function (b, i) {
          ['on:click', 'on:pointerenter'].forEach(function (attr) {
            var val = b.getAttribute(attr);
            if (val) b.setAttribute(attr, val.replace(/\/\d+$/, '/' + i));
          });
          b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        });
      }

      /* THE THEME REPLACES THE WHOLE GALLERY, AND THAT IS WHAT MOVES THE SHOPPER.

         `variant-picker` answers a change by fetching the section and calling
         media-gallery.replaceWith(fresh markup). The new element starts at
         scrollLeft 0, so whatever photograph the shopper had scrolled to is
         gone. Profiled on a 4x-throttled phone: parked on photograph 4, tap a
         SIZE -- which does not change the picture at all -- and the gallery
         lands back on photograph 1. On the theme alone that happens at 2.4s;
         with the old pin it also happened at 0.5s, twice for one tap.

         Guessed timers cannot cover that: the morph is at ~800ms on a laptop
         and ~2400ms on a phone. So watch for the replacement itself, once, and
         put the shopper back on the media id they were looking at. */
      var holdId = null;
      var SHOWN = {};

      /* WHY THE PHOTOGRAPH BLINKS OUT AND COMES BACK.

         The swap paints the right photograph in the click's own frame. Then,
         ~800ms to 2.4s later, the theme replaces the entire <media-gallery>
         with the server's markup — a brand new <img> element, which has no
         decoded bitmap yet even when the bytes are in cache. For the frames
         between insertion and decode the box paints empty, so the picture that
         was already correct disappears and returns. Nothing is wrong by then;
         it is the cost of throwing the element away and building a new one.

         The element cannot be kept, but the pixels can: the URL that was on
         screen a moment ago is decoded and free to paint, so it goes behind the
         new <img> as a background. An <img> with nothing decoded shows its own
         background, so the shopper sees the same photograph without a gap; the
         moment the real bitmap is ready it paints over the top and the
         background is dropped. */
      function coverUntilPainted(gal, mediaId) {
        var url = SHOWN[String(mediaId)];
        if (!url) return;
        var root = gal.querySelector('slideshow-slides') || gal;
        var slides = slideList(root);
        for (var i = 0; i < slides.length; i++) {
          if (mediaIdOf(slides[i]) !== String(mediaId)) continue;
          var img = slides[i].querySelector('img');
          if (!img || (img.complete && img.naturalWidth > 0)) return;
          img.style.backgroundImage = 'url("' + url + '")';
          img.style.backgroundSize = 'cover';
          img.style.backgroundPosition = 'center';
          var drop = function () {
            img.style.backgroundImage = '';
            img.style.backgroundSize = '';
            img.style.backgroundPosition = '';
          };
          if (img.decode) img.decode().then(drop, drop);
          else { img.addEventListener('load', drop, { once: true }); img.addEventListener('error', drop, { once: true }); }
          // Never leave a background behind a picture that failed to arrive.
          setTimeout(drop, 4000);
          return;
        }
      }

      /* THE RAIL AND EVERY UNCHANGED PHOTOGRAPH SURVIVE THE REPLACEMENT.

         media-gallery.js answers a variant change with
         `this.replaceWith(newMediaGallery)` — the whole element, parsed from the
         server's HTML, thrown in as brand-new nodes. Every <img> in it is a new
         element with NO decoded bitmap, and an <img> with no bitmap paints
         nothing: no opacity change, no transform, no class, just a hole. That is
         why the frame-by-frame flicker check of 2026-09-11 reported 0 faded and
         0 transformed frames while the owner was watching the gallery blink.

         Measured on globe-pull-chain-wall-sconce at 433px, one variant tap:
         nine photographs were each carried by 2 to 4 different <img> elements,
         and some on-screen image had no bitmap on 11 sampled frames spanning
         1037ms. The rail is the visible part of it — eight thumbnails, all
         re-created, none of whose pictures changed.

         The bytes are not the problem: those URLs are in the browser's cache
         and the requests do not even reach the network. The ELEMENT is the
         problem. So where the server's new <img> asks for exactly what an old
         one already has on screen — same src, same srcset, same sizes, so the
         browser would resolve the identical URL — the old element is moved into
         the new gallery instead. Moving a loaded <img> does not re-fetch and
         does not re-decode: the bitmap comes with it, and there is no hole.

         Only images that are genuinely painted are offered, and only exact
         attribute matches are taken, so a photograph that really did change is
         left to the server's own element. */
      /* A <picture> CHILD IS NOT ADOPTED, AND THAT IS DELIBERATE.

         An <img> inside a <picture> does not choose its URL from its own srcset:
         the <source> elements decide first, and MOVING the element re-runs that
         choice against whatever sources it lands among. Measured on
         globe-pull-chain-wall-sconce: adopting picture children grew a variant
         tap by two requests at width=1080 (160 KB) for photographs the gallery
         was already showing at 800 — the reuse cost more than the reload it
         replaced. Matching the sources as well as the img did not fix it, so
         the rule is the conservative one: only an <img> whose URL is settled by
         its own attributes is offered.

         That still covers what the owner is looking at. The thumbnail rail —
         eight bare <img> elements, no <picture>, unchanged URLs across a variant
         change — is exactly the set this protects, and the rail is the part of
         the gallery that visibly rebuilt. */
      function imageSignature(img) {
        var src = img.getAttribute('src') || '';
        var ss = img.getAttribute('srcset') || '';
        if (!src && !ss) return null;
        // Inside a <picture> the element's own attributes are not the whole
        // answer, so it is not offered for adoption at all — see below.
        if (img.parentElement && img.parentElement.tagName === 'PICTURE') return null;
        return src + '|' + ss + '|' + (img.getAttribute('sizes') || '');
      }

      function adoptPainted(oldGal, newGal) {
        if (!oldGal || !newGal || newGal.getAttribute('data-hl-adopted') === '1') return 0;
        newGal.setAttribute('data-hl-adopted', '1');
        var pool = {};
        [].slice.call(oldGal.querySelectorAll('img')).forEach(function (img) {
          if (!(img.complete && img.naturalWidth > 0)) return;   // nothing to carry over
          var k = imageSignature(img);
          if (k && !pool[k]) pool[k] = img;
        });
        var n = 0;
        [].slice.call(newGal.querySelectorAll('img')).forEach(function (fresh) {
          var k = imageSignature(fresh);
          var kept = k && pool[k];
          if (!kept || kept === fresh) return;
          delete pool[k];
          /* Everything the server's markup says about this element EXCEPT what
             chooses the picture. src/srcset/sizes are equal by construction —
             that is what the signature means — and re-setting src to its own
             value re-runs the browser's image algorithm, which is the one thing
             this whole function exists to avoid. */
          for (var i = 0; i < fresh.attributes.length; i++) {
            var a = fresh.attributes[i];
            if (a.name === 'src' || a.name === 'srcset' || a.name === 'sizes') continue;
            if (kept.getAttribute(a.name) !== a.value) kept.setAttribute(a.name, a.value);
          }
          fresh.replaceWith(kept);
          n++;
        });
        return n;
      }

      function watchMorph(fn) {
        var gal = SCOPE.querySelector('media-gallery');
        var parent = gal && gal.parentElement;
        if (!parent) return;
        var mo = new MutationObserver(function () {
          var now = SCOPE.querySelector('media-gallery');
          if (!now || now === gal) return;
          mo.disconnect();
          // Before anything reads or scrolls the new gallery: the observer
          // callback is a microtask, so the fresh <img> elements have not had a
          // frame to paint their emptiness yet.
          adoptPainted(gal, now);
          fn(now);
        });
        mo.observe(parent, { childList: true });
        setTimeout(function () { mo.disconnect(); }, 6000);
      }

      function holdPlace(mediaId) {
        if (!mediaId) return;
        holdId = String(mediaId);
        var covering = String(mediaId);
        watchMorph(function (gal) {
          coverUntilPainted(gal, covering);          // before anything moves
          if (!holdId) return;                       // the shopper took over
          var root = gal.querySelector('slideshow-slides');
          if (!root) return;
          var slides = slideList(root);
          for (var i = 0; i < slides.length; i++) {
            if (mediaIdOf(slides[i]) !== holdId) continue;
            if (i === 0) return;                     // already where it belongs
            ownScroll(root, slideStart(root, slides[i]));
            return;
          }
        });
      }

      /* Where a slide begins, in the scroller's own coordinates.

         `index * root.clientWidth` was wrong, and wrong in the direction that
         produced the reported bug. Measured on a 412px phone: clientWidth is
         515 but the slide pitch is 478 — the strip shows 91% of a slide plus an
         8px gap so the peek reveals the next photograph. Dividing scrollLeft by
         515 mis-identifies which slide is on screen, and multiplying by 515
         restores to a position that is not a slide start, which scroll-snap
         then corrects — back to the beginning.

         offsetLeft is the real number and costs no layout of its own, because
         the slides are the scroller's own children. */
      function slideStart(root, slide) {
        var first = root.querySelector('slideshow-slide');
        return slide.offsetLeft - (first ? first.offsetLeft : 0);
      }

      function visibleSlide(root) {
        var slides = slideList(root);
        if (!slides.length) return null;
        var x = root.scrollLeft, best = slides[0], bestD = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(slideStart(root, slides[i]) - x);
          if (d < bestD) { bestD = d; best = slides[i]; }
        }
        return best;
      }

      /* The photograph the selected variant is currently showing. The server
         renders that variant's media first, so the opening slide is the truth
         at load; after that this code owns it. */
      var CURRENT = null;
      function initCurrent() {
        var first = SCOPE.querySelector('media-gallery slideshow-slide [data-media-id]');
        if (first) CURRENT = first.getAttribute('data-media-id');
      }

      var pinUntil = 0, pinOwn = false;

      /* pinOwn means "the next scroll event on the gallery is mine, ignore it".
         It is only honest if a scroll event is actually going to arrive:
         writing scrollLeft the value it already holds fires nothing, and the
         flag then sits armed until the shopper's NEXT real swipe, which the
         listener below swallows — so the gesture that was meant to END the pin
         is the one that gets eaten, and the pin yanks them back to the first
         photograph anyway. Both writers go through here so neither can arm it
         without moving the scroller, and the two-frame reset covers the case
         where the browser coalesces the event away regardless. The reset is
         safe against the real event because scroll events are dispatched in the
         rendering update BEFORE animation-frame callbacks, so a genuine event
         always reaches the listener first. */
      function ownScroll(root, to) {
        if (!root || root.scrollLeft === to) return false;
        var prev = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        pinOwn = true;
        root.scrollLeft = to;
        root.style.scrollBehavior = prev;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { pinOwn = false; });
        });
        return true;
      }

      function pinStart() {
        ownScroll(slidesRoot(), 0);
      }
      /* A scroll the shopper started ends the pin immediately. pointerdown and
         touchstart already do this for a finger, but momentum, a trackpad and a
         thumbnail click all move the strip without one — and a pin that pulls
         the gallery back to the first photograph while someone is browsing it
         is far worse than the problem it solves. */
      document.addEventListener('scroll', function (e) {
        if (!pinUntil && !holdId) return;
        if (!e.target || !e.target.closest || !e.target.closest('media-gallery')) return;
        if (pinOwn) { pinOwn = false; return; }
        /* A scroll this code did not cause ends BOTH the pin and the hold.
           Clearing only the pin left a hold armed from the previous choice, and
           when the theme's replacement landed a moment later it pulled the
           shopper back to that older photograph -- measured on live: pick a
           colour, swipe to photograph 4, tap a size, and the gallery jumped to
           photograph 1 at t=708ms. Momentum, a trackpad and a thumbnail tap all
           arrive here without a pointerdown, which is why this listener has to
           do it rather than the gesture listeners below. */
        pinUntil = 0;
        holdId = null;
      }, true);

      function showVariant(v) {
        var root = slidesRoot();
        if (!root || !v) return;
        var slides = slideList(root);
        if (!slides.length) return;
        // The gallery may not have existed when this script was parsed.
        if (CURRENT === null) initCurrent();

        /* A size, a power rating, a length -- the rows whose variants all share
           one photograph with the variant already selected. There is nothing to
           swap, so the reorder, the pin, the thumbnail rebuild and the zoom
           rebuild were all cost, and the pin was itself the yank back to the
           first photograph.

           The question is NOT "is the variant's photograph the one on screen" --
           a shopper three photographs into the gallery is looking at a lifestyle
           shot that belongs to no variant, and answering that question with the
           visible slide sent every tap down the swap path. The question is
           whether the VARIANT's photograph changed. */
        if (!v.mediaId || String(v.mediaId) === String(CURRENT)) {
          var here = visibleSlide(root);
          holdPlace(here && mediaIdOf(here));
          return;
        }
        CURRENT = String(v.mediaId);

        var target = null;
        for (var i = 0; i < slides.length; i++) {
          if (mediaIdOf(slides[i]) === String(v.mediaId)) { target = slides[i]; break; }
        }
        if (!target) {
          target = BUILT[v.mediaId] || buildSlide(slides[0], v);
          if (!target) return;
          BUILT[v.mediaId] = target;
        }

        /* REMOVE AND INSERT IN THE SAME FRAME — never one without the other.

           The removal loop used to run HERE, synchronously, while the insertion
           below waits on img.decode(). On a warm cache both land in the click's
           own frame and nobody sees the gap. On a cold one the outgoing
           variant's slide was already gone and the strip fell back to whatever
           came next in it — a lifestyle photograph belonging to no variant at
           all. Measured on live with the CDN slowed to 2.5s: 8 slides became 7
           at t=95ms showing an unrelated picture, and it stayed until the
           server's own gallery landed at t=755ms. That is the reported
           "ảnh main cứ bị ở variant 1, đôi lúc stuck".

           The decode gate's comment used to claim it "keeps the previous
           photograph on screen until the new one can replace it". It could not:
           the previous photograph is the outgoing variant's, which is exactly
           what this loop deletes. So the strip is now not touched at all until
           the new photograph can paint, and the shopper keeps looking at the
           variant they came from while it loads. */
        var img = target.querySelector('img');
        /* The photograph on screen right now, captured before anything moves.
           If the incoming one cannot paint yet, this is what goes behind it so
           the box is never empty — the same trick coverUntilPainted uses at the
           server's morph, applied to the swap itself. */
        var leaving = root.querySelector('slideshow-slide img');
        var leavingUrl = leaving && leaving.currentSrc;

        var done = false;
        var place = function () {
          if (done) return;
          done = true;
          /* A slow click must not beat a newer one. CURRENT is assigned
             synchronously above, so it names the variant actually wanted; a
             decode that resolves after the shopper has moved on is dropped
             rather than painted over the top of their real choice. */
          if (String(v.mediaId) !== String(CURRENT)) return;
          /* Not decoded yet — paint the outgoing photograph behind it so the
             swap reads as "not there yet" rather than as a hole. Dropped the
             moment the real bitmap is ready. */
          if (img && !(img.complete && img.naturalWidth > 0) && leavingUrl) {
            img.style.backgroundImage = 'url("' + leavingUrl + '")';
            img.style.backgroundSize = 'cover';
            img.style.backgroundPosition = 'center';
            var drop = function () {
              img.style.backgroundImage = '';
              img.style.backgroundSize = '';
              img.style.backgroundPosition = '';
            };
            if (img.decode) img.decode().then(drop, drop);
            else { img.addEventListener('load', drop, { once: true }); img.addEventListener('error', drop, { once: true }); }
            setTimeout(drop, 4000);
          }
          // The URL the browser actually resolved and decoded for this slide.
          // It is the only URL known to be paintable this instant, which is
          // what the anti-blink cover below needs.
          if (img && img.currentSrc) SHOWN[String(v.mediaId)] = img.currentSrc;
          // Read the strip again rather than trusting the list captured at
          // click time: a pending swap may have changed it since.
          slideList(root).forEach(function (s) {
            if (s === target) return;
            var id = mediaIdOf(s);
            if (s.getAttribute('data-hl-injected') === '1' || (id && VARIANT_MEDIA[id])) s.remove();
          });
          var firstSlide = root.querySelector('slideshow-slide');
          if (target !== firstSlide) root.insertBefore(target, firstSlide);
          target.setAttribute('aria-hidden', 'false');
          renumber(root);
          syncZoom(v);
          syncThumbnails(v);
          pinStart();
        };
        if (!img || (img.complete && img.naturalWidth > 0)) place();
        else {
          if (img.decode) img.decode().then(place, place);
          else { img.onload = place; img.onerror = place; }
          /* THE GATE NEEDS A DEADLINE, and this is the whole reason the gallery
             could stop responding altogether.

             Measured on live, on the warmed width=1080 rung with no network
             request outstanding: img.complete stayed false and img.decode()
             stayed PENDING for more than four seconds, while naturalWidth was
             already 1080 — the bytes were arriving, the promise simply had not
             settled. Shopify generates the derivative on first request
             (`last-modified` equal to the request time, server-timing
             imageryProcess ~145ms), so a photograph nobody has asked for before
             is exactly the slow case, and every variant is that on a first
             visit.

             With the swap gated on that promise alone, place() never ran: the
             gallery sat on whatever slide was in front and IGNORED every
             further click, because each one only re-armed the same gate.
             Reproduced five clicks in a row, six seconds each, zero change.

             120ms is above a warm decode (~1ms, the normal path keeps its
             single-paint swap) and below the threshold where a tap stops
             feeling connected to what the finger did. */
          setTimeout(place, 120);
        }

        /* The strip is already at its start and the theme's replacement arrives
           at 0 too, so this is a guard, not a correction. A per-frame loop was
           running 54 times to write nothing; three checks around the morph
           cover the same window without occupying the main thread. */
        pinUntil = Date.now() + 900;
        [0, 320, 780].forEach(function (d) {
          setTimeout(function () { if (Date.now() <= pinUntil) pinStart(); }, d);
        });
        // The server puts this photograph first, so the morph handler will find
        // it at index 0 and do nothing -- but if a future change reorders the
        // gallery, the shopper still ends up looking at the right picture.
        holdPlace(v.mediaId);
      }

      // A shopper's own swipe always wins over the pin.
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
        document.addEventListener(type, function (e) {
          if (e.target && e.target.closest && e.target.closest('media-gallery')) {
            pinUntil = 0;
            holdId = null;
          }
        }, { capture: true, passive: true });
      });

      /* The swatch name beside the option label.

         Measured: the picture became Dark Blue in the click's own frame while
         the legend still read "Color Black" for the next ~600ms, until the
         server's markup arrived. Two sources of truth on screen at once, and
         the wrong one is the one written in words. The value is already known
         from the input that was just checked, so it costs nothing to keep them
         in step. */
      function paintOptionLabels(picker) {
        [].slice.call(picker.querySelectorAll('fieldset')).forEach(function (fs) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          var out = fs.querySelector('legend .variant-option__swatch-value');
          if (checked && out && out.textContent !== checked.value) out.textContent = checked.value;
        });
      }

      function selectedTitle(picker) {
        var checked = picker.querySelectorAll('input[type="radio"]:checked');
        var parts = [];
        for (var i = 0; i < checked.length; i++) parts.push(checked[i].value);
        return parts.join(' / ');
      }

      /* THE MAP IS KEYED BY THE FULL VARIANT TITLE; THE PICKER ONLY KNOWS WHAT IT DRAWS.

         The map's keys are Shopify's variant titles, every option joined by
         " / " — "A / 60x80cm". selectedTitle() joins the checked RADIOS, and
         the theme draws no radio for an option with a single value, so a product
         with Color (A, B) plus Size (60x80cm only) looked up "A", missed, and the
         gallery stayed put with no error anywhere. Exact title first; otherwise
         the key whose segments contain every selected value, in order. The
         option the shopper cannot see has exactly one value, so the match is
         unique for it. */
      function mapEntry(title) {
        if (MAP[title]) return MAP[title];
        var want = title.split(' / ');
        for (var i = 0; i < TITLES.length; i++) {
          var have = TITLES[i].split(' / '), at = 0;
          for (var j = 0; j < have.length && at < want.length; j++) if (have[j] === want[at]) at++;
          if (at === want.length) return MAP[TITLES[i]];
        }
        return null;
      }

      function showStableSlide(gal, mediaId) {
        var slides = gal.querySelectorAll('slideshow-slide');
        var thumbs = gal.querySelectorAll('.slideshow-controls__thumbnail');
        for (var i = 0; i < slides.length; i++) {
          if (mediaIdOf(slides[i]) !== String(mediaId)) continue;
          var chosen = gal.querySelector('.slideshow-controls__thumbnail[aria-selected="true"]');
          if (thumbs[i] === chosen) return;
          /* The same glide a thumbnail tap makes: the photograph travels to its
             target and the index stays in step with it. */
          if (thumbs[i]) thumbs[i].click();
          return;
        }
      }

      document.addEventListener('change', function (event) {
        var input = event.target;
        if (!input || input.type !== 'radio') return;
        var picker = input.closest('variant-picker');
        if (!picker || input.closest('product-card') || input.closest('quick-add-dialog')) return;
        /* Aim every lookup at the gallery this picker belongs to. */
        var host = input.closest('[data-pm-mount]');
        var want = host || document;
        if (want !== SCOPE) rescope(want, host ? (host.__hlVM || {}) : PAGE_MAP);
        paintOptionLabels(picker);
        /* Stable gallery: every photograph is already a slide, so the variant's
           photograph is reached the way a shopper reaches any other: a tap on its
           thumbnail, which glides there. */
        var gal = SCOPE.querySelector('media-gallery[data-hl-stable]');
        if (gal) {
          var sv = mapEntry(selectedTitle(picker));
          if (sv && sv.mediaId) showStableSlide(gal, sv.mediaId);
          return;
        }
        /* holdPlace arms watchMorph, but it returns early when there is no
           media id to hold — and the replacement still happens, still throwing
           every <img> away. The adoption has to be armed by the CHANGE, not by
           whether there is a slide worth pinning. */
        watchMorph(function () {});
        var v = mapEntry(selectedTitle(picker));
        if (v) showVariant(v);
      }, true);

      /* Warming every variant photograph is what makes the swap instant, but
         requestIdleCallback with a 2.5s timeout fires DURING the load on a slow
         phone — measured: the page was still 9s from DOMContentLoaded — so the
         warm-up was competing with the page it was meant to improve. It waits
         for the load event now, and steps aside entirely on a metered or 2G
         connection, where the decode gate in showVariant still keeps the old
         photograph on screen until the new one is ready. */
      function warm() {
        var c = navigator.connection;
        /* Warm only on a fast connection. 3g and slower would spend the bytes the open page needs. */
        if (c && (c.saveData || (c.effectiveType && c.effectiveType !== '4g'))) return;
        preload();
        prebuild();
      }
      initCurrent();

      function rescope(scope, map) {
        SCOPE = scope;
        setMap(map);
        CURRENT = null;
        initCurrent();
      }
      /* Called by hl-pdp-modal.js once a product page has been mounted: `map`
         is {variant title: {mediaId, src, thumb, alt, ratio}}, the same shape
         #hl-variant-media has on the product page. */
      window.HLVariantSwap = {
        attach: function (scope, map) {
          if (!scope) return;
          scope.__hlVM = map || {};
          rescope(scope, scope.__hlVM);
          warm();
        }
      };

      function scheduleWarm() {
        if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
        else setTimeout(warm, 600);
      }
      if (document.readyState === 'complete') scheduleWarm();
      else window.addEventListener('load', scheduleWarm, { once: true });
    })();
